import { styled } from "@mui/material";

export const Container = styled('div')({
  textAlign: 'center',
  position: 'relative',
  display: 'inline-block',
});

export const Overlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
});

export const Content = styled('div')({
  width: '80%',
  height: '85%',
  borderRadius: '20px',
  overflow: 'hidden',
});
